export default {
  'not_found': 'NOT FOUND',
  'not_found_explanation': 'You just hit a route that doesn\'t exist... the sadness.',
};
